module.exports = __webpack_public_path__ + "img/desc.52153a38.png";